import { createStore } from "vuex";
import { auth } from './auth';
import { game } from './game';
import { onboarding } from './onboarding';
import { config } from './config';

export default createStore({
  modules:{
    auth,
    game,
    onboarding,
    config
  }
});